<template>
  <div class="card height-100" id="honoraire">
    <header class="header-card">
      <p>
        {{ $t('editionClient.generalTitle.periodeBudgetaire')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns">
        <div class="column is-6">
          <b-field :label="$t('editionClient.periodeBudgetaire.debutMois')">
            <b-select v-model="client.moisDebutPeriodeBudgetaire" expanded>
              <option/>
              <option v-for="mois in listeMois"
                      :key="mois.nbMois"
                      :value="mois.nbMois">
                {{ mois.libelle }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('editionClient.periodeBudgetaire.finMois')">
            <b-select v-model="client.moisFinPeriodeBudgetaire" expanded>
              <option/>
              <option v-for="mois in listeMois"
                      :key="mois.nbMois"
                      :value="mois.nbMois">
                {{ mois.libelle }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { LISTE_MOIS } from '@/configuration/datePickerConf';
import ucFirst from '@/services/general/ucFirst';

export default {
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      listeMois: [],
    };
  },
  mounted() {
    for (let i = 0; i < LISTE_MOIS.length; i += 1) {
      this.listeMois.push({
        libelle: ucFirst(LISTE_MOIS[i]),
        nbMois: i + 1,
      });
    }
  },
};
</script>
